import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const stored = localStorage.getItem("cap-malaisie-lang");
      return stored === "en" ? "en" : "fr";
    } catch (e) {
      return "fr";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("cap-malaisie-lang", lang);
      document.documentElement.lang = lang;
    } catch (e) {
      // ignore storage errors
    }
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang((prev) => (prev === "fr" ? "en" : "fr"));
  }, []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
